import React, { Fragment, } from 'react'

export default function Page404() {
    return (
        <Fragment>
            <h1>Page not found</h1>
        </Fragment>
    )
}